import type { Sections, SegmentReach } from '../../../types';

type DetailedSectionObject = Exclude<Sections, 'source_provided_count' | 'source_matched_count'>;

export const createSectionsForReachTooltip = (segmentReach: SegmentReach): Sections => {
  const detailedSectionKeys = Object.keys(segmentReach?.source_detailed_counts || {});
  const detailedSection = detailedSectionKeys.reduce<DetailedSectionObject>((acc, key) => {
    if (segmentReach?.source_detailed_counts?.[key]?.provided) {
      acc[`${key}_provided`] = segmentReach?.source_detailed_counts?.[key]?.provided;
      acc[`${key}_matched`] = segmentReach?.source_detailed_counts?.[key]?.matched;
    }

    return acc;
  }, {});

  if (detailedSection) {
    return {
      source_provided_count: segmentReach?.source_provided_count,
      source_matched_count: segmentReach?.source_matched_count,
      ...detailedSection,
    };
  }

  return { source_provided_count: segmentReach?.source_provided_count };
};
